import { MIND_MODE, WS_MIND_TYPE } from '@mindverse/accessor-open';
import { createContext } from 'react';

import type { EAppMode } from '../utils/const';
import { DEFAULT_APP_MODE } from '../utils/const';

export interface IBasicInfo {
  mindId: string;
  sessionId: string;
  userId?: string | number;
  appMode: EAppMode; // 当前生效的模式
  configMode: EAppMode; // 配置的模式
  inChatMode: boolean;
  isShared: boolean;
  mindType: WS_MIND_TYPE;
  mode?: MIND_MODE;
  chatType?: 'normal' | 'spaceCollapse' | 'spaceExpand' | 'homepage' | 'circle';
}

const ContextBasicInfo = createContext<IBasicInfo>({
  mindId: '',
  sessionId: '',
  userId: '',
  appMode: DEFAULT_APP_MODE,
  configMode: DEFAULT_APP_MODE,
  inChatMode: false,
  isShared: false,
  mindType: WS_MIND_TYPE.original,
  mode: MIND_MODE.PERSONAL,
  chatType: 'normal'
});

export default ContextBasicInfo;
